$shm_hitalama_components_launch $shm_hitalama_components_preview
	minimal_width 480
	demo_model $shm_hitalama_components_demo
		definition <= definition
		kind \default
	tools /
		<= Edit $mol_link
			hint \Описание и код приложения
			arg <= edit_arg *
			sub / <= Edit_icon $mol_icon_cog
